import React, { useState } from 'react';
import { X } from 'lucide-react';
import { equipmentAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

export default function AddRunLog({ equipmentId, onClose, onSaved }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    log_date: new Date().toISOString().slice(0, 10),
    start_time: '',
    end_time: '',
    total_hours: '',
    purpose: '',
    fuel_used: '',
    operator_id: user?.id || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form };
      if (payload.total_hours) payload.total_hours = parseFloat(payload.total_hours);
      if (payload.fuel_used) payload.fuel_used = parseFloat(payload.fuel_used);
      await equipmentAPI.addRunLog(equipmentId, payload);
      onSaved();
    } catch (err) {
      alert(err.message || 'Failed to add run log');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'input-primary';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">Add Run Log</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
            <input type="date" name="log_date" value={form.log_date} onChange={handleChange} required className={inputCls} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
              <input type="time" name="start_time" value={form.start_time} onChange={handleChange} className={inputCls} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">End Time</label>
              <input type="time" name="end_time" value={form.end_time} onChange={handleChange} className={inputCls} />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Total Hours (if not auto-calc)</label>
            <input type="number" step="0.1" name="total_hours" value={form.total_hours} onChange={handleChange} className={inputCls} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Purpose</label>
            <input name="purpose" value={form.purpose} onChange={handleChange} className={inputCls} placeholder="e.g. Mowing, Rolling" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fuel Used</label>
            <input type="number" step="0.01" name="fuel_used" value={form.fuel_used} onChange={handleChange} className={inputCls} />
          </div>
          <div className="flex gap-3 pt-4">
            <button type="submit" disabled={loading} className="btn-primary-solid disabled:opacity-50">
              {loading ? 'Saving...' : 'Save'}
            </button>
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
